import React from "react";

const Loader = () => {
  return (
    <div 
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        width: "100%",
        gap: "16px"
      }}
    >
      <div className="premium-spinner"></div>
      <span 
        style={{
          color: "var(--text-secondary)",
          fontSize: "14px",
          fontWeight: 500,
          fontFamily: "var(--font-family)",
          letterSpacing: "0.5px"
        }}
      >
        Loading...
      </span>
      <style>{`
        .premium-spinner {
          width: 44px;
          height: 44px;
          border: 3.5px solid var(--border-color);
          border-top: 3.5px solid var(--primary-main);
          border-radius: 50%;
          animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loader;
